import React from 'react'

const Feature = ({ title, description, faIcon, dataId, position }) => {
  const icon = (
    <div>
      <i
        className={`fa fa-${faIcon} gradient-color waves-effect waves-light`}
        aria-hidden="true"
      />
    </div>
  )
  return (
    <div className="single-feature p-tb-2">
      <a className="hoverable feature-link same-height" data-owl-item={dataId}>
        {position === 'right' && icon}
        <div>
          <h5>{title}</h5>
          <p>{description}</p>
        </div>
        {position === 'left' && icon}
      </a>
    </div>
  )
}

export default function FeaturesSection({ title, features }) {
  return (
    <section
      id="features"
      data-scroll-index="1"
      className="main-section center-align"
    >
      <div className="gradient-color overlay" />

      <div className="container">
        {/*<!--Title-->*/}
        <h4 className="reflection-text reflection-text-white p-b-2">{title}</h4>

        <div className="row p-t-2">
          <div className="col s12 m12 l4 p-tb-1 feature-left">
            {features
              .slice(0, 3)
              .map((f, i) => (
                <Feature {...f} dataId={i} key={f.title} position="left" />
              ))}
          </div>

          <div className="col push-m3 push-s3 s6 m6 l4 p-tb-1 images-slider">
            {/*<!--Features Images-->*/}
            <div className="owl-carousel owl-features">
              {features.map(({ title, image }) => (
                <div key={title}>
                  <img alt="" className="responsive-img" {...image} />
                </div>
              ))}
            </div>
          </div>
          <div className="col s12 m12 l4 p-tb-1 feature-right">
            {features
              .slice(3, 6)
              .map((f, i) => (
                <Feature {...f} dataId={i + 3} key={f.title} position="right" />
              ))}
          </div>
        </div>
      </div>
    </section>
  )
}



// WEBPACK FOOTER //
// ./src/components/Sections/FeaturesSection.js